module.exports = parcelRequire.resolve("c6ObA");